<div
  class="multi-select"
  *ngIf="control"
  (clickOutside)="handleOutSideClick()"
  inClickOutside
>
  <label class="multi-select__label" *ngIf="config.title"
    >{{ config.title }} <span *ngIf="config.required">*</span></label
  >
  <div
    class="multi-select__holder"
    (click)="toggleOption(true)"
    [ngClass]="{ flex: multiselect }"
  >
    <div
      class="multi-select__holder-wrap align-center flex-wrap"
      attr.data-placeholder="{{ config.placeholder }}"
      [ngClass]="{ 'is-value': control.value.label, 'is-single': !multiselect }"
    >
      <ng-container *ngIf="!multiselect">
        <div
          class="multi-select__single"
          attr.data-placeholder="{{ config.placeholder }}"
        >
          {{ control.value.label | titlecase }}
        </div>
      </ng-container>
      <ng-container *ngIf="multiselect">
        <ng-container *ngFor="let option of control.value">
          <div
            class="multi-select__holder-chip"
            *ngIf="option[config.labelField || 'label']"
          >
            {{ option[config.labelField || "label"] }}

            <img
              src="assets/images/close-white.svg"
              alt="x"
              (click)="removeOption(option[config.valueField || 'value'])"
            />
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <div class="multi-select__error" *ngIf="error">
    {{ error }}
  </div>

  <div
    [ngClass]="
      showOptions ? 'multi-select__dropdown active' : 'multi-select__dropdown'
    "
    [style]="'max-height:' + maxHeight"
  >
    <ul>
      <ng-container *ngIf="searchable && config.allowSearchFilter">
        <li class="is-search">
          <form [formGroup]="searchForm">
            <input
              type="text"
              [placeholder]="config.searchPlaceholderText || 'Search...'"
              formControlName="searchText"
            />
          </form>
        </li>
      </ng-container>
      <ng-container *ngIf="optionLoading; else optionsTemp">
        <li *ngFor="let i of [].constructor(4)">
          <ng-container *ngIf="multiselect">
            <app-skeleton
              width="20px"
              height="20px"
              radius="4px"
            ></app-skeleton>
          </ng-container>
          <div style="width: calc(100% - 30px)">
            <app-skeleton
              width="100%"
              height="12px"
              radius="2px"
              margin="0 0 0 10px"
            ></app-skeleton>
          </div>
        </li>
      </ng-container>
    </ul>
  </div>
</div>

<ng-template #optionsTemp>
  <ng-container *ngIf="multiselect">
    <li
      (mousedown)="handleOptionClick('all'); $event.stopPropagation()"
      *ngIf="!config.allowPagination"
    >
      <span
        [ngClass]="selectedOption?.length === options.length ? 'active' : ''"
      ></span
      >Select All
    </li>
  </ng-container>
  <ng-container *ngFor="let option of options; let i = index">
    <li
      (mousedown)="handleOptionClick(option); $event.stopPropagation()"
      [ngClass]="{
        active:
          !multiselect &&
          selectedOption === option[config.valueField || 'value'],
        disabled: option?.isDisabled
      }"
    >
      <ng-container *ngIf="multiselect">
        <span
          [ngClass]="
            selectedOption?.includes(option[config.valueField || 'value'])
              ? 'active'
              : ''
          "
        ></span>
      </ng-container>
      <p>
        {{
          option?.displayLabel
            ? option?.displayLabel
            : option[config.labelField || "label"]
        }}
      </p>
    </li>
  </ng-container>
  <ng-container *ngIf="pagination">
    <li
      *ngIf="!paginationLoading && pagination; else lastElement"
      inViewport
      [lastElement]="true"
      (elementIsVisible)="handleLastElementIsVisible()"
    >
      <ng-container *ngIf="multiselect">
        <app-skeleton width="20px" height="20px" radius="4px"></app-skeleton>
      </ng-container>
      <div style="width: calc(100% - 30px)">
        <app-skeleton
          width="100%"
          height="12px"
          radius="2px"
          margin="0 0 0 10px"
        ></app-skeleton>
      </div>
    </li>
  </ng-container>
</ng-template>

<ng-template #lastElement>
  <li>
    <ng-container *ngIf="multiselect">
      <app-skeleton width="20px" height="20px" radius="4px"></app-skeleton>
    </ng-container>
    <div style="width: calc(100% - 30px)">
      <app-skeleton
        width="100%"
        height="12px"
        radius="2px"
        margin="0 0 0 10px"
      ></app-skeleton>
    </div>
  </li>
</ng-template>
